import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { CitietouristicService } from 'src/app/api/tourism/citietouristic.service';
import { GeneralService } from 'src/app/api/config/general.service';
import { ToolsService } from 'src/app/utils/tools.service';
import { ServicehotelExtendsComponent } from 'src/app/config/servicehotel/servicehotel-extends/servicehotel-extends.component';
import { TourService } from 'src/app/api/tourism/tour.service';
import { HttpHeaders } from '@angular/common/http';
import SwalAlert from 'src/app/utils/swalalert';
declare var $: any;

@Component({
  selector: 'app-tour-form',
  templateUrl: './tour-form.component.html',
  styleUrls: ['./tour-form.component.css']
})
export class TourFormComponent implements OnInit {
  @ViewChild(ServicehotelExtendsComponent) ServicehotelExtendsComponent: any;

  branchofficeSlug: string = '';
  nameMenu: string = 'information_general';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;
  save_add: boolean = false;

  citiestouristic: any;
  shifttours: any;
  // fortmat pdf 
  selectedPdfFile: any | null = null;
  fileUrlImage: any = null;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private routeActivated: ActivatedRoute,
    private el: ElementRef,
    private renderer: Renderer2,
    private globalService: GlobalService,
    private tourService: TourService,
    private generalService: GeneralService,
    private citieTouristicService: CitietouristicService,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private navigationTrackerService: NavigationTrackerService,
    private alert: SwalAlert,
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.routeActivated.snapshot.params['id'];
    this.item = this.fb.group({
      description: ['', [Validators.required, Validators.minLength(2)]],
      citietouristic_id: ['', [Validators.required]],
      shift: ['', [Validators.required]],
      price_public: ['', [Validators.required]],
      price_corporate: ['', [Validators.required]],
      price_package: ['', [Validators.required]],
      price_web: ['', [Validators.required]],
      price_utility: [null],
      time_duration: [''],

      include: [''],
      tourist_program: [''],
      comment: [''],
      url_file: [null],
      url_image_itinerary: [null],
      slug: [null],
      is_show_web: [true],

      // detail_typesbedroom: this.fb.array([])
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;      
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.routeActivated);
    // set initial values =============
    this.getCitieTouristic();
    this.getShiftTours();
    (<any>$('[data-toggle="tooltip"]')).tooltip();    
    if (this.isEdit) {      
      this.editData();
    }
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }
  
  editData() {
    (<any>$('#item_description')).focus();
    this.tourService.get(this.checkId).subscribe({
      next: (data: any) => {
        let _item = data.data;
        this.item.patchValue({
          slug: _item.slug,
          description: _item.description,
          citietouristic_id: _item.citietouristic_id,
          shift: _item.shift,
          price_public: _item.price_public,
          price_corporate: _item.price_corporate,
          price_package: _item.price_package,
          price_web: _item.price_web,
          price_utility:_item.price_utility,
          time_duration: _item.time_duration,
          include: _item.include,
          tourist_program: _item.tourist_program,
          comment: _item.comment,
          url_file: _item.url_file,
          url_image_itinerary: _item.url_image_itinerary,          
          is_show_web: _item.is_show_web,          
        });
      }
    });
  }

  // FUNCTIONS LOADS DATAS
  getCitieTouristic() {
    this.citieTouristicService.all().subscribe({
      next: (data: any) => {
        this.citiestouristic = data.results;
      }
    });
  }

  getShiftTours() {
    this.generalService.listShiftTours().subscribe({
      next: (data: any) => {
        this.shifttours = data;
      }
    });
  }

  onFileItinerarySelected(event: any): void {
    const file = event.target.files[0];
    if (this.toolsService.validateSizeImg(file)) {
      this.fileUrlImage = event.target.files[0];
      // this.previewImage(file);
    }
  }

  onFileSelected(event: any): void {
    const file: File = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      if (this.validateSizeImg(file)) {
        this.selectedPdfFile = file;
      }
    } else {
      this.selectedPdfFile = null;
      (<any>$('#file_pdf')).val(null);
      // alert('Por favor, seleccione un archivo PDF.');
      this.alert.warning('Por favor, seleccione un archivo PDF.');
    }
  }

  validateSizeImg(file: any, isMulti: boolean = false) {
    const maxSize = 1024 * 1024; // 1MB in bytes
    if (file) {
      if (file.size / maxSize > environment.max_size_file) {
        let _txt = 'El tamaño del archivo seleccionado (' + file.name + ')';        
        this.alertifyMsg.warning(
          _txt +
            ' excede el límite permitido (1 MB). Elija un archivo más pequeño; ó reduzca el tamaño del archivo.', 10
        );
        return false;
      }
    }

    return true;
  }

  removeFilePdf(){
    this.item.patchValue({
      url_file: null,
    });
  }

  removeFileItinerary(){
    this.item.patchValue({
      url_image_itinerary: null,
    });
  }


  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }

    let data: any = {};

    if (this.validate()) {
      data.item = this.item.value;

      const formData = new FormData();
      const headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');
      formData.append('item', JSON.stringify(data));
      formData.append('url_file', this.selectedPdfFile);
      formData.append('url_image_itinerary', this.fileUrlImage);

      if (this.isEdit) {
        formData.append('id', JSON.stringify(this.checkId));
        this.tourService.updateSave(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            // this.routerBack();
            this.editData();
          }
        });
      } else {
        this.tourService.save(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.routerBack();
          }
        });
      }
    }
  }

  validate() {
    //  validate type bedrooms

    return true;
  }

  resetForm() {
    this.submitted = false;
    this.item.reset();
    (<any>$('#item_description')).focus();
  }

  cancel() {
    this.routerBack();
  }

  routerBack() {
    this.router.navigate([this.branchofficeSlug + '/turismo/tours/lista']);
  }
}
